function Rr(series) {
  var n = series.length,
    o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}
export { Rr as default };
//# sourceMappingURL=none.js.map
